module.exports = __webpack_public_path__ + "img/icon-bank.e9bcd571.png";